import * as React from "react";
import * as ReactDOM from "react-dom";
import { PropsWithChildren } from "react";

export interface IDocumentBodyPortalComponentProps {
    document: Document;
}

/**
 * Helper component that will render its children at the end of the document body, instead of the current location in the DOM tree
 */
export class DocumentBodyPortalComponent extends React.Component<PropsWithChildren<IDocumentBodyPortalComponentProps>> {
    render() {
        return ReactDOM.createPortal(this.props.children, this.props.document.body);
    }
}
